// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"534":"c44915e6","585":"a24f271a","712":"b4ee6a8a"}[chunkId] + ".chunk.css";
};